import React from 'react';

const LoadingSpinner = () => {
    return (
        <div className="loading-spinner">
            <img src="/pokeball.png" alt="Pokeball" className="pokeball" />
        </div>
    );
};

export default LoadingSpinner;